import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { UPDATE_REGION } from "../apiRoutes";

const mutateUpdateGeoRegion = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${UPDATE_REGION}${id}`, data);
};

const useUpdateGeoRegionsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateGeoRegion,
    ...queryParams,
  });

export default useUpdateGeoRegionsMutation;
